import type { PayloadAction } from '@reduxjs/toolkit';

import { SET_RECAPTCHA_VISIBLE, type RecaptchaVisible } from './types';

const initialState: RecaptchaVisible = false;

export function recaptchaVisibleReducer(
	state = initialState,
	action: PayloadAction<RecaptchaVisible>,
): RecaptchaVisible {
	switch (action.type) {
		case SET_RECAPTCHA_VISIBLE:
			return action.payload || initialState;
		default:
			return state;
	}
}
